@if (helpService.$isOpen()) {
  <div 
    class="n-help-overlay"
    [class.n-help-overlay-mobile]="helpService.$isMobile()"
    (click)="onOverlayClick($event)"
    (keydown.escape)="helpService.closeHelp()"
    tabindex="-1"
  >
    <div 
      class="n-help-drawer" 
      [class.n-help-drawer-mobile]="helpService.$isMobile()"
      (click)="$event.stopPropagation()"
      (keydown)="$event.stopPropagation()"
      tabindex="0"
    >
      <!-- Header do Drawer / Bottom Sheet -->
      <div class="n-help-header">
        <div class="n-help-header-left">
          @if (helpService.$activeArticle()) {
            <button 
              type="button" 
              class="n-help-btn-icon" 
              (click)="helpService.selectArticle(null)"
              [attr.aria-label]="'HELP.UI.VOLTAR' | translate"
            >
              <i class="pi pi-arrow-left"></i>
            </button>
          } @else {
            <i class="pi pi-question-circle n-help-logo-icon"></i>
          }
          <span class="n-help-header-title">
            {{ helpService.$activeArticle()?.title || ('HELP.UI.TITULO' | translate) }}
          </span>
        </div>

        <button 
          type="button" 
          class="n-help-btn-icon n-help-close-btn" 
          (click)="helpService.closeHelp()"
          [attr.aria-label]="'HELP.UI.FECHAR' | translate"
        >
          <i class="pi pi-times"></i>
        </button>
      </div>

      <!-- Barra de Pesquisa (quando em modo lista) -->
      @if (!helpService.$activeArticle()) {
        <div class="n-help-search-box">
          <div class="p-input-icon-left w-full">
            <i class="pi pi-search"></i>
            <input 
              type="text" 
              class="n-help-search-input" 
              [placeholder]="'HELP.UI.BUSCA' | translate" 
              [value]="helpService.$searchQuery()"
              (input)="onSearchInput($event)"
            />
            @if (helpService.$searchQuery()) {
              <i 
                class="pi pi-times n-search-clear" 
                role="button"
                tabindex="0"
                (click)="helpService.setSearchQuery('')"
                (keyup.enter)="helpService.setSearchQuery('')"
              ></i>
            }
          </div>
        </div>
      }

      <!-- Conteúdo Principal -->
      <div class="n-help-body">
        <!-- VIZUALIZAÇÃO DO ARTIGO -->
        @if (helpService.$activeArticle(); as article) {
          <div class="n-help-article-view">
            <div class="n-help-article-meta">
              <span class="n-help-badge">
                <i [class]="article.icon"></i> {{ article.category }}
              </span>
            </div>

            <div class="n-help-article-content" [innerHTML]="article.contentHtml"></div>

            <div class="n-help-article-footer">
              <button 
                type="button" 
                class="n-help-btn-primary" 
                (click)="helpService.closeHelp()"
              >
                <i class="pi pi-check"></i> {{ 'HELP.UI.ENTENDI' | translate }}
              </button>
            </div>
          </div>
        } 
        <!-- LISTA DE CATEGORIAS E ARTIGOS -->
        @else {
          <div class="n-help-categories-list">
            @for (cat of helpService.$filteredCategories(); track cat.id) {
              <div class="n-help-cat-group">
                <div 
                  class="n-help-cat-header" 
                  role="button"
                  tabindex="0"
                  (click)="helpService.toggleCategory(cat.id)"
                  (keyup.enter)="helpService.toggleCategory(cat.id)"
                >
                  <div class="n-help-cat-title">
                    <i [class]="cat.icon"></i>
                    <span>{{ cat.title }}</span>
                  </div>
                  <i 
                    class="pi" 
                    [class.pi-chevron-down]="helpService.$expandedCategories()[cat.id]"
                    [class.pi-chevron-right]="!helpService.$expandedCategories()[cat.id]"
                  ></i>
                </div>

                @if (helpService.$expandedCategories()[cat.id]) {
                  <div class="n-help-articles-grid">
                    @for (article of cat.articles; track article.id) {
                      <div 
                        class="n-help-article-card" 
                        role="button"
                        tabindex="0"
                        (click)="helpService.selectArticle(article)"
                        (keyup.enter)="helpService.selectArticle(article)"
                      >
                        <div class="n-help-card-icon">
                          <i [class]="article.icon"></i>
                        </div>
                        <div class="n-help-card-info">
                          <h4>{{ article.title }}</h4>
                          <p>{{ article.summary }}</p>
                        </div>
                        <i class="pi pi-chevron-right n-card-arrow"></i>
                      </div>
                    }
                  </div>
                }
              </div>
            } @empty {
              <div class="n-help-empty-search">
                <i class="pi pi-search-minus"></i>
                <p>{{ 'HELP.UI.SEM_RESULTADO' | translate }} "<strong>{{ helpService.$searchQuery() }}</strong>"</p>
                <button type="button" class="n-help-btn-secondary" (click)="helpService.setSearchQuery('')">
                  {{ 'HELP.UI.VER_TODOS' | translate }}
                </button>
              </div>
            }
          </div>
        }
      </div>
    </div>
  </div>
}

<!-- Botão Flutuante (FAB) desativado momentaneamente (Descomentar para ativar)
@if (!helpService.$isOpen()) {
  <button 
    type="button" 
    class="n-help-fab-btn" 
    (click)="helpService.openHelp()"
    [title]="'GLOBAL.CENTRAL_AJUDA' | translate"
    [attr.aria-label]="'GLOBAL.ABRIR_CENTRAL_AJUDA' | translate"
  >
    <i class="pi pi-question-circle"></i>
  </button>
}
-->



